module.exports = __webpack_public_path__ + "static/media/pid_survey_complete.e188ea6c.svg";